/** The three stakeholder views. */
export const VIEWS = [
    { id: "staff", label: "Staff", who: "Joel Pannikot", blurb: "Everything going on in governance" },
    { id: "committee", label: "Governance Committee", who: "Cedric Thompson, Chair", blurb: "Runs the projects and follows up with committees" },
    { id: "group", label: "A committee", who: "Curriculum & Testing Committee", blurb: "What to do, when and why" },
] as const;

export type ViewId = typeof VIEWS[number]["id"];

export const SCREEN_LABEL: Record<string, string> = Object.fromEntries(VIEWS.map((v) => [v.id, v.label]));

/** What a reviewer's comment can be about, per view. */
export const ANCHORS: Record<ViewId, string[]> = {
    staff: ["Projects overview", "Numbers at the top", "Where staff can help", "Recent activity", "All committees table", "Pause switches"],
    committee: ["Numbers at the top", "Committees to follow up", "Reminding a Chair", "Reports from committees", "Board packet", "Every committee table", "Global CDC and its regions"],
    group: ["The four steps", "What to do now", "Planning the year", "Confirming the minutes", "Next meeting & agenda", "Policy review on the agenda", "What was decided", "Member's view"],
};
